import React from 'react'

export interface AutomationViewActionsListCardProps {
  icon: React.ReactNode
  title: React.ReactNode
  subtitle?: React.ReactNode
}

export const AutomationViewActionsListCard = ({
  icon,
  title,
  subtitle,
}: AutomationViewActionsListCardProps) => {
  return (
    <div className="flex w-full">
      <div className="flex w-full items-center gap-3 text-left">
        <div className="h-10 w-10 [&>svg]:h-10 [&>svg]:w-10">{icon}</div>
        <div className="flex flex-col gap-1">
          <span className="font-bold text-[15px] text-textPrimary">
            {title}
          </span>
          {subtitle && (
            <span className="text-M text-textTertiary">{subtitle}</span>
          )}
        </div>
      </div>
    </div>
  )
}
